<template>
  <div class="header">
    <div class="headerStart"></div>
    <div class="headerEnd"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
/* IMPORT VARIABLES */
@import "@/styles/_variables.scss";

.header {
  display: flex;
  flex-direction: row;
  border-bottom: 5px solid $dark-blue-color;
}

.headerStart {
  flex: 0 0 800px;
  background-image: url(../assets/Header1.jpg);
  height: 80px;
}

.headerEnd {
  flex: 1;
  background-image: url(../assets/Header2.jpg);
  background-repeat: repeat-x;
}

@media only screen and (max-width: 800px) {
  .headerStart {
    flex: 0 0 100%;
  }

  .headerEnd {
    display: none;
  }
}
</style>
